var youbora = require('youboralib')
require('./adapter')

module.exports = youbora



//////////////////
// WEBPACK FOOTER
// ./src/sp.js
// module id = 55
// module chunks = 0